import './Button.scss';
import LoadingCompSmall from "../LoadingComp/LoadingCompSmall";
import {Tooltip} from "react-tooltip";

export default function Button(
    {
        value = "",
        onClick = () => {},
        loading = false,
        className = "",
        type = "button",
        disabled = false,
        icon = null,
        whiteLoader = true,
        tooltip= '',
        ...props
    }
) {
    return (
        <button type={type}
                disabled={disabled || loading}
                className={"btn " + className}
                onClick={() => onClick()}
                {...props}
                data-tooltip-id={tooltip}
        >
            {
                loading ?
                    <LoadingCompSmall white={whiteLoader}/>
                    :
                    <>

                        {
                            icon ?
                                <i className={icon + (value.length > 0 ? " me-2" : "")}></i>
                                :null
                        }
                        {value}
                        <Tooltip id={tooltip} content={tooltip} />
                    </>
            }
        </button>
    );
}

